@if (recents?.documents?.length > 0) {
  <div>
    <rask-list [data]="recents.documents" [showHeader]="false">
      <rask-list-column>
        <ng-template let-row="row">
          @if (row.iconUrl) {
            <rask-arbetsorder-info-icon [forceImageUrl]="row.iconUrl"></rask-arbetsorder-info-icon>
          }
          @if (!row.iconUrl) {
            <i class="fa" [ngClass]="getIcon(row.type)"></i>
          }
        </ng-template>
      </rask-list-column>
      <rask-list-column>
        <ng-template let-row="row">
          @if (hasLink(row)) {
            <span>
              {{ row.label }} <a [routerLink]="getRoute(row)" [queryParams]="getRouteParams(row)">{{ row.name }}</a>
            </span>
          }
          @if (!hasLink(row)) {
            <span>{{ row.name }} {{ row.label }}</span>
          }
        </ng-template>
      </rask-list-column>
      <rask-list-column>
        <ng-template let-row="row">
          <span [ngbTooltip]="row.timestamp | date:'yyyy-MM-dd HH:mm'">{{ row.timestamp | relative }}</span>
        </ng-template>
      </rask-list-column>
    </rask-list>
  </div>
}